// Packages
import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

// Components
import FormTemplate from 'components/BTDUI/FormTemplate';
import BTDTextField from 'components/BTDUI/fields/BTDTextField';
import BTDButton from 'components/BTDUI/BTDButton';

const TestSpecificationForm = ({ errors, testSpecification, onClose, onSubmit, type, }) => {

    const [data, setData] = useState({})
	const [changedData, setChangedData] = useState({})
    

    // Load Item values into form
	useEffect(() => {

		if ( testSpecification )
		{
            setData(testSpecification);
		}

	}, [testSpecification]);


    return(
        <FormTemplate onClose={() => {onClose()}}>

            <h3 className="form__title medium">{type === 'create' ? 'Create test specification' : 'Edit test specification'}</h3>

            <BTDTextField
                error={errors && errors.name ? errors.name : null} 
                label='Name'
                onChange={(value) => {
                    setData({...data, name: value});
                    setChangedData({...changedData, name: value});
                }} 
                required={true}
                tabIndex={1}
                value={data.name ?? ''} 
            />

            <BTDTextField
                error={errors && errors.code ? errors.code : null} 
                label='Code'
                onChange={(value) => {
                    setData({...data, code: value});
                    setChangedData({...changedData, code: value});
                }} 
                required={true}
                tabIndex={2}
                value={data.code ?? ''} 
            />

            <BTDButton 
                formButton={true}
                label={type === 'create' ? 'Save test specification' : 'Update test specification'}
                onClick={() => {onSubmit(changedData)}} 
            ></BTDButton>

        </FormTemplate>
    )

}

TestSpecificationForm.propTypes = {
	errors: PropTypes.object,
	procedure: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    onClose: PropTypes.func,
	onSubmit: PropTypes.func,
    type: PropTypes.string
}

TestSpecificationForm.defaultProps = {
    errors: {},
    procedure: null,
	onSubmit: () => {alert('onSubmit is not set')},
	onClose: () => {alert('onClose is not set')},
    type: 'create'
}

export default TestSpecificationForm;